import styled from 'styled-components';

const SectionName = styled.h3`
  letter-spacing: 4px;
  font-size: 25px;
  font-variant: petite-caps;
  border: 2px solid #0353a4;
  padding: 10px;
  background-color: #b9d6f2;
  text-align: center;
`;

export default SectionName;
